import { render } from "./compliance.cattle.io.clusterscanprofile.vue?vue&type=template&id=71c6a6f8"
import script from "./compliance.cattle.io.clusterscanprofile.vue?vue&type=script&lang=js"
export * from "./compliance.cattle.io.clusterscanprofile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__